import { Alert, Box, Button, TextField, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Colors, getColorWithAlpha } from '~/libs/mui/theme'

interface WithdrawalConfirmProps {
  /** 入力済みテキスト */
  defaultInputText: string
  error?: string
  onSubmit: () => void
  onClickCancel: () => void
  onChangeFreeTextReason: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export function WithdrawalConfirm({
  defaultInputText,
  error,
  onSubmit,
  onClickCancel,
  onChangeFreeTextReason,
}: WithdrawalConfirmProps): JSX.Element {
  const { t } = useTranslation()
  return (
    <Box>
      {error && (
        <Alert severity='error' sx={{ mb: 1 }}>
          {error}
        </Alert>
      )}
      <Typography fontWeight={500}>
        {t('please_tell_us_your_feedback_to_help_us_improve_our_service')}
      </Typography>
      <TextField
        fullWidth
        multiline
        defaultValue={defaultInputText}
        placeholder={t('enter_your_feedback')}
        variant='outlined'
        rows={6}
        sx={{ mt: { xs: 1, sm: 2 } }}
        onChange={onChangeFreeTextReason}
      />
      <Box display='flex' flexDirection='column' mt={{ xs: 10, sm: 7 }} gap={{ xs: 1, sm: 2 }}>
        <Button
          sx={{
            background: getColorWithAlpha(Colors.colorCE492C, 0.7),
            color: getColorWithAlpha(Colors.colorD7D9DB, 0.7),
          }}
          onClick={onSubmit}
        >
          {t('complete_unsubscribe')}
        </Button>
        <Button
          sx={{
            backgroundColor: Colors.color1A1A18,
            color: Colors.color7E7E80,
          }}
          onClick={onClickCancel}
        >
          {t('cancel_withdrawal')}
        </Button>
      </Box>
    </Box>
  )
}
